import { render, staticRenderFns } from "./NfseFranchise.vue?vue&type=template&id=5bf93505&"
import script from "./NfseFranchise.vue?vue&type=script&lang=js&"
export * from "./NfseFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports